export enum BookStepsEnum {
  Prompt = 'prompt',
  SelectType = 'selectType',
  PickDate = 'pickDate',
  LocationTime = 'locationTime',
  ConfirmPayment = 'confirmPayment',
  ConfirmationInfo = 'ConfirmationInfo',
}
